import React from 'react'
import { createPortal } from 'react-dom'
import styled from '@emotion/styled'
import { Modal } from '@mobi/component-library/Overlays/Modal'
import { Icon } from '@mobi/component-library/Common/V2/Icon'
import { Button } from '@mobi/component-library/Common/V2'
import { colors, font, layering, spacing } from '@mobi/component-library/Theme/Common'

export const ExpertHubFirstPostModal: React.FC<ExpertHubFirstPostModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null

  return createPortal(
    <Modal isOpen={isOpen} zIndex={layering.overlayHigh} dismissStatus='disallowed'>
      <WrapperStyled>
        <header>
          <div>
            <Icon name='LineAlertTriangle' color={colors.warning[600]} size='2.4rem' />
          </div>

          <h2>Are you sure you want to post?</h2>

          <p>
            All posts to Expert Hub are final and will be <br />
            visible to everyone.
          </p>
        </header>
        <div>
          <Button
            data-testid='ConfirmPostToExpertHub'
            size='md'
            isFullWidth
            color='primary'
            onClick={onConfirm}
          >
            Post to Expert Hub
          </Button>

          <Button size='md' isFullWidth color='secondary_grey' onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </WrapperStyled>
    </Modal>,
    document.body
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  '> header': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: spacing.bigx1,
    fontFamily: font.family.primary,

    '> div:first-of-type': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '4.8rem',
      height: '4.8rem',
      marginBottom: spacing.md,
      borderRadius: '50%',
      background: colors.warning[50],

      '> span': { transform: 'translateY(-0.1rem)' },
    },

    '> h2': {
      marginBottom: spacing.smx1,

      fontSize: font.size.xl2.fontSize,
      letterSpacing: font.size.xl2.letterSpacing,
      lineHeight: font.size.xl2.lineHeight,
      fontWeight: font.weight.semibold,

      color: colors.neutral[900],
      textShadow: 'none',
      textTransform: 'unset',
    },

    '> p': {
      margin: 0,
      fontSize: font.size.lg.fontSize,
      letterSpacing: font.size.lg.letterSpacing,
      lineHeight: font.size.lg.lineHeight,
      fontWeight: font.weight.regular,

      color: colors.neutral[700],
      textWrap: 'balance',
    },
  },

  '> div:last-of-type': {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.smx1,
    width: '100%',
  },
})

//=========
// Types
//=========

type ExpertHubFirstPostModalProps = {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
}
